export const GARAGE_MAP_CONTENT_COMPONENT_NAME = 'GarageMap';
